import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

import { MenuComponent } from './menu.component';

@NgModule({
    exports: [MenuComponent],
    declarations: [MenuComponent],
    imports: [CommonModule, RouterModule, IonicModule, TranslateModule],
    providers: [InAppBrowser, provideHttpClient(withInterceptorsFromDi())]
})
export class MenuModule {}
